<mat-card>
  <mat-card-content class="flex flex-col gap-y-[var(--mx-table-card-vertical-gap)] px-2 py-4">
    <div class="flex flex-row justify-between items-center">
      @switch (leftHeaderContent) {
        @case ('NONE') {
          <div></div>
        }
        @case ('SEARCH') {
          <ng-container *ngTemplateOutlet="searchBox; context: { classes: 'mx-search-box w-[16rem] min-w-28' }"/>
        }
        @case ('SELECT_SEARCH') {
          <div [class]="isMultiSearch ? 'mx-select-search-input flex w-[22rem]' : 'mx-select-search-input flex w-[20rem] min-w-28'">
            @if (isMultiSearch) {
              <mx-select-form-field fieldName="searchSelect" overrideLabel="" [formGroup]="formGroup" [options]="searchableAttributes"
                                    [includeUndefinedOption]="false" class="mx-search-select min-w-[6.5rem] max-w-[9rem]"
                                    optionsPanelClass="mx-search-select-dropdown-panel"/>
              <mat-divider [vertical]="true" class="my-1"/>
            }
            <ng-container *ngTemplateOutlet="searchBox; context: { classes: 'mx-search-input mx-search-box flex-1' }"/>
          </div>
        }
        @default {
          <div class="{{ leftHeaderText.cssClasses }} ps-2 text-nowrap">
            {{ leftHeaderText.valueSelector | select }}
          </div>
        }
      }

      <mx-action-buttons>
        <mx-table-card-header-filters [definitions]="filterDefinitions"/>
        <mx-table-card-header-actions [definitions]="actionDefinitions"/>

        @if (printDefinition) {
          <mat-divider vertical class="self-stretch ms-1 my-1"/>

          <button mat-icon-button mxPreventFocus matTooltip="Print" color="primary" [disabled]="!(enablePrintButton | select:false)"
                  (click)="onClickPrintButton()">
            <mat-icon class="material-icons-outlined">print</mat-icon>
          </button>
        }
      </mx-action-buttons>
    </div>

    <mx-table [tableDefinition]="tableDefinition"/>

    <div class="empty:hidden px-0 md:px-4">
      <ng-content select="[footer]"/>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #searchBox let-classes="classes">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" [class]="classes">
    <mat-icon matIconPrefix class="mat-icon-size-5 -me-2">search</mat-icon>
    <input #searchInput matInput value="{{ routerSelectors.queryParamValue('query') | select:'' }}"
           (input)="onInputInSearchBox()" (keydown.enter)="onKeydownEnterInSearchBox()" [placeholder]="searchSelectPlaceholder"
           class="placeholder:text-outline"/>
    @if (showSearchClearButton) {
      <button matSuffix mat-icon-button class="mat-icon-button-size-8" (click)="onClickSearchClearButton()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</ng-template>
